import React, {useState, useEffect} from "react";



export default function EditPanelInputSelect({thisRef, options}){
	
	const thisStyle = {
		display:"flex",
		width:"313px",
		height:"32px",
		minHeight:"20px",
		border:"1px solid #999",
		color:"black",
		backgroundColor:"rgba(0,0,0,0)",
		borderRadius:"4px",
		fontSize:"12px",
		fontFamily:"helvetica"
	};

	
	const optionDisplay = options.map((item, index) => 
		<option value={item.value}>
				{item.text}
			</option>
	);
	
	return (
		<select style={thisStyle} ref={thisRef}>
			<option value="-100">Select</option>
			{optionDisplay}
		</select>
	);
}